// Simple translations object
const pt = {
  nav: { services: "Serviços", portfolio: "Portfolio", whyUs: "Porquê Nós", pricing: "Preços", contact: "Contacto", cta: "Agendar Consultoria" },
  hero: {
    badge: "Criado por Médico para Médicos",
    subtitle: "Criação de sites médicos em Portugal. Websites profissionais que transmitem confiança, autoridade e geram marcações.",
    subtitle2: "Compreendemos a comunicação médica e SEO para especialidades.",
    features: ["Sites para clínicas privadas", "SEO local para médicos", "Design premium certificado", "Integração WhatsApp e marcações"],
    ctaPrimary: "Agendar Consultoria",
    ctaSecondary: "Ver Exemplos",
    priceFrom: "A partir de",
  },
  services: {
    badge: "Web Design Médico",
    title: "Criação de Sites Médicos",
    highlight: "em Portugal",
    main: { title: "Websites para Médicos", desc: "Ao contrário das agências generalistas, compreendemos as regras de publicidade médica e a importância da reputação profissional.", features: ["Currículo Médico Online", "Portal do Consultório", "Sistema de Marcações"] },
    seo: { title: "SEO para Médicos", desc: "Posicionamento no Google para atrair pacientes da sua região e especialidade." },
    branding: { title: "Branding Médico", desc: "Identidade visual que reflecte profissionalismo e credibilidade médica." },
    copy: { title: "Copywriting Médico", desc: "Textos éticos que comunicam autoridade." },
    responsive: { title: "Design Responsivo", desc: "Perfeito em todos os dispositivos." },
    gdpr: { title: "RGPD Compliance", desc: "Proteção de dados garantida." },
  },
  portfolio: {
    badge: "Portfolio",
    title: "Exemplos de",
    highlight: "Sites Médicos",
    subtitle: "Design premium inspirado nas melhores clínicas europeias.",
    cta: "Quer um site profissional para o seu consultório?",
    ctaBtn: "Solicitar Orçamento",
  },
  whyUs: {
    badge: "Porque Somos Diferentes",
    title: "Criado por Médico",
    highlight: "para Médicos",
    desc: "Somos especializados em criação de sites médicos em Portugal. Compreendemos a comunicação médica e SEO adaptado a especialidades.",
    specLabel: "Especialidades que servimos:",
    specs: ["Dentistas", "Cirurgiões Plásticos", "Medicina Estética", "Dermatologia", "Oftalmologia", "Cardiologia"],
    reasons: [
      { title: "Conhecimento Médico", desc: "Compreendemos a comunicação e marketing médico.", stat: "100%", label: "Especializado" },
      { title: "Entrega Rápida", desc: "O seu website pronto em semanas, não meses.", stat: "3-4", label: "Semanas" },
      { title: "SEO Local", desc: "Apareça no Google para pacientes da sua região.", stat: "A+", label: "Ranking" },
      { title: "Suporte Dedicado", desc: "Acompanhamento personalizado em todas as fases.", stat: "24/7", label: "Disponível" },
    ],
  },
  pricing: {
    badge: "Investimento",
    title: "Preço",
    highlight: "Transparente",
    subtitle: "Um investimento único para uma presença digital profissional que atrai pacientes.",
    cardBadge: "Website Completo",
    priceFrom: "A partir de",
    priceNote: "Pagamento único • Sem mensalidades escondidas",
    includedTitle: "O Que Está Incluído",
    features: ["Design Premium Personalizado", "Copywriting Médico Especializado", "Optimização SEO Local", "Design Responsivo (Mobile-First)", "Integração WhatsApp", "Integração com Google Maps", "Certificado SSL", "Suporte 30 Dias Incluído"],
    ctaBtn: "Solicitar Orçamento",
    disclaimer: "* Preço final pode variar conforme requisitos específicos do projecto",
    maintTitle: "Custos de Manutenção",
    maintDesc: "Após a entrega do website, existem custos opcionais para manter o site online e para alterações futuras.",
    hosting: { price: "~€10/mês", title: "Hosting & Domínio", desc: "Custo para manter o seu website online 24/7 com domínio personalizado e certificado SSL." },
    changes: { price: "Sob Consulta", title: "Alterações Futuras", desc: "Modificações posteriores ao website têm um custo adicional baseado na complexidade do pedido." },
    hostingNote: "O hosting é opcional — pode optar por alojar o site noutro servidor à sua escolha.",
    deposit: "Entrada • 50% na entrega",
    revisions: "Revisões durante o projecto",
  },
  contact: {
    badge: "Contacto",
    title: "Vamos Criar o Seu",
    highlight: "Site Médico",
    desc: "Pronto para ter uma presença digital profissional? Fale connosco e entraremos em contacto em menos de 24 horas.",
    emailLabel: "Email",
    trust: "Os Seus Dados Estão Seguros",
    ssl: "SSL Seguro",
    gdpr: "RGPD Compliant",
    form: { name: "Nome Completo", namePh: "Dr. João Silva", spec: "Especialidade", specPh: "Medicina Estética", email: "Email", emailPh: "dr.joao@email.com", msg: "Mensagem", msgPh: "Descreva o seu projecto...", submit: "Enviar Mensagem", sending: "A Enviar...", response: "Resposta garantida em menos de 24 horas" },
    success: "Mensagem enviada com sucesso!",
    successDesc: "Entraremos em contacto em breve.",
    error: "Erro ao enviar mensagem",
    errorDesc: "Por favor, tente novamente mais tarde.",
  },
  footer: { tagline: "Criação de Sites Médicos em Portugal", privacy: "Política de Privacidade", terms: "Termos de Serviço", copyright: "Todos os direitos reservados." },
};

const en = {
  nav: { services: "Services", portfolio: "Portfolio", whyUs: "Why Us", pricing: "Pricing", contact: "Contact", cta: "Book Consultation" },
  hero: {
    badge: "Created by Doctor for Doctors",
    subtitle: "Medical website creation in Portugal. Professional websites that convey trust, authority and generate appointments.",
    subtitle2: "We understand medical communication and specialty SEO.",
    features: ["Sites for private clinics", "Local SEO for doctors", "Premium certified design", "WhatsApp & booking integration"],
    ctaPrimary: "Book Consultation",
    ctaSecondary: "View Examples",
    priceFrom: "Starting from",
  },
  services: {
    badge: "Medical Web Design",
    title: "Medical Website Creation",
    highlight: "in Portugal",
    main: { title: "Websites for Doctors", desc: "Unlike generalist agencies, we understand medical advertising rules and the importance of professional reputation.", features: ["Online Medical CV", "Practice Portal", "Booking System"] },
    seo: { title: "SEO for Doctors", desc: "Google positioning to attract patients from your region and specialty." },
    branding: { title: "Medical Branding", desc: "Visual identity that reflects professionalism and medical credibility." },
    copy: { title: "Medical Copywriting", desc: "Ethical texts that communicate authority." },
    responsive: { title: "Responsive Design", desc: "Perfect on all devices." },
    gdpr: { title: "GDPR Compliance", desc: "Data protection guaranteed." },
  },
  portfolio: {
    badge: "Portfolio",
    title: "Examples of",
    highlight: "Medical Websites",
    subtitle: "Premium design inspired by the best European clinics.",
    cta: "Want a professional website for your practice?",
    ctaBtn: "Request Quote",
  },
  whyUs: {
    badge: "Why We're Different",
    title: "Created by Doctor",
    highlight: "for Doctors",
    desc: "We specialize in medical website creation in Portugal. We understand medical communication and SEO adapted to medical specialties.",
    specLabel: "Specialties we serve:",
    specs: ["Dentists", "Plastic Surgeons", "Aesthetic Medicine", "Dermatology", "Ophthalmology", "Cardiology"],
    reasons: [
      { title: "Medical Knowledge", desc: "We understand medical communication and marketing.", stat: "100%", label: "Specialized" },
      { title: "Fast Delivery", desc: "Your website ready in weeks, not months.", stat: "3-4", label: "Weeks" },
      { title: "Local SEO", desc: "Appear on Google for patients in your region.", stat: "A+", label: "Ranking" },
      { title: "Dedicated Support", desc: "Personalized guidance throughout all phases.", stat: "24/7", label: "Available" },
    ],
  },
  pricing: {
    badge: "Investment",
    title: "Transparent",
    highlight: "Pricing",
    subtitle: "A one-time investment for a professional digital presence that attracts patients.",
    cardBadge: "Complete Website",
    priceFrom: "Starting from",
    priceNote: "One-time payment • No hidden fees",
    includedTitle: "What's Included",
    features: ["Custom Premium Design", "Medical Copywriting", "Local SEO Optimization", "Responsive Design (Mobile-First)", "WhatsApp Integration", "Google Maps Integration", "SSL Certificate", "30 Days Support Included"],
    ctaBtn: "Request Quote",
    disclaimer: "* Final price may vary according to specific project requirements",
    maintTitle: "Maintenance Costs",
    maintDesc: "After website delivery, there are optional costs to keep the site online and for future changes.",
    hosting: { price: "~€10/month", title: "Hosting & Domain", desc: "Cost to keep your website online 24/7 with custom domain and SSL certificate." },
    changes: { price: "On Request", title: "Future Changes", desc: "Subsequent modifications have an additional cost based on complexity." },
    hostingNote: "Hosting is optional — you can choose to host the site on another server.",
    deposit: "Deposit • 50% on delivery",
    revisions: "Revisions during the project",
  },
  contact: {
    badge: "Contact",
    title: "Let's Create Your",
    highlight: "Medical Website",
    desc: "Ready for a professional digital presence? Contact us and we'll get back to you within 24 hours.",
    emailLabel: "Email",
    trust: "Your Data Is Secure",
    ssl: "SSL Secure",
    gdpr: "GDPR Compliant",
    form: { name: "Full Name", namePh: "Dr. John Smith", spec: "Specialty", specPh: "Aesthetic Medicine", email: "Email", emailPh: "dr.john@email.com", msg: "Message", msgPh: "Describe your project...", submit: "Send Message", sending: "Sending...", response: "Response guaranteed within 24 hours" },
    success: "Message sent successfully!",
    successDesc: "We'll be in touch soon.",
    error: "Error sending message",
    errorDesc: "Please try again later.",
  },
  footer: { tagline: "Medical Website Creation in Portugal", privacy: "Privacy Policy", terms: "Terms of Service", copyright: "All rights reserved." },
};

export const translations = { pt, en };
export default translations;
